<template>
  <div class="courses">
    <siteHeader />
    
    <!-- 轮播图区域 -->
    <div class="slider-container">
      <div class="slider">
        <div class="slide">
          <el-carousel
            height="400px"
            :interval="3000"
            trigger="hover"
            :autoplay="true"
            v-if="bannerList.length"
            indicator-position="outside">
            <el-carousel-item v-for="item in bannerList" :key="item.id">
              <div class="slide-content" :style="{ backgroundImage: `url(${item.url})` }"></div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    
    <div class="content">
      <div class="container">
        <breadcrumb :paths="['培训课程']" />

        <div class="page-content">
          <div class="left-nav">
            <h3>培训课程</h3>
            <ul>
              <li 
                v-for="(category, index) in categories" 
                :key="index"
                :class="{ active: activeCategory === index }"
                @click="activeCategory = index"
              >
                {{ category.name }}
              </li>
            </ul>
          </div>

          <div class="right-content">
            <div class="course-images">
              <img 
                v-for="(category, index) in categories" 
                :key="index" 
                :src="require(`@/assets/${category.id}.png`)" 
                :alt="category.name"
                :class="{ active: activeCategory === index }"
                class="course-img"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <siteFooter />
  </div>
</template>

<script>
import siteHeader from '@/components/SiteHeader.vue'
import siteFooter from '@/components/SiteFooter.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import { websiteApi } from '@/api'

export default {
  name: 'CoursesPage',
  components: {
    siteHeader,
    siteFooter,
    Breadcrumb
  },
  data() {
    return {
      activeCategory: 0,
      categories: [
        { name: '消防培训', id: 'xiaofang' },
        { name: '档案培训', id: 'dangan' },
        { name: '新闻培训', id: 'xinwen' }
      ],
      bannerList: []
    }
  },
  created() {
    this.getBanners()
  },
  methods: {
    async getBanners() {
      try {
        const res = await websiteApi.getPictureList()
        if (res.code === 200) {
          // 筛选出 location 为 1 的轮播图数据
          this.bannerList = res.rows
            .filter(item => item.location === 1)
            .map((item) => ({
              id: item.id,
              url: item.carouselUrl,
              title: "",
              subtitle: "",
              description: item.remark || "",
            }))
        }
      } catch (error) {
        console.error("获取顶部轮播图失败：", error)
      }
    }
  }
}
</script>

<style scoped>
.courses {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
  padding: 20px 0 40px 0;
  background: transparent;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.page-content {
  display: flex;
  gap: 30px;
  margin-top: 20px;
}

.left-nav {
  width: 200px;
  background: transparent;
  padding: 20px;
  border-radius: 4px;
  position: sticky;
  top: 80px;
  align-self: flex-start;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
  color: #dddddd;
}

.left-nav h3 {
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  color: #333;
}

.left-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.left-nav li {
  padding: 12px 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 4px;
  margin-bottom: 5px;
}

.left-nav li:hover {
  background-color: rgba(0,0,0,0.05);
}

.left-nav li.active {
  color: #0b0b0b;
  background-color: #d8d8d8;
}

.right-content {
  flex: 1;
  background: transparent;
  padding: 0;
}

.course-images {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
}

.course-img {
  width: 100%;
  height: auto;
  margin-bottom: 0;
  display: block;
}

.course-img:not(.active) {
  display: none;
}

/* 轮播图样式 */
.slider-container {
  width: 100%;
  overflow: hidden;
}

.slider {
  width: 100%;
}

.slide {
  width: 100%;
}

.slide-content {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

:deep(.el-carousel__container) {
  height: 400px;
}

:deep(.el-carousel__item) {
  height: 100%;
}

:deep(.el-carousel__indicators) {
  bottom: 20px;
}

:deep(.el-carousel__button) {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.7);
}

:deep(.el-carousel__arrow) {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  width: 40px;
  height: 40px;
}

:deep(.el-carousel__arrow:hover) {
  background-color: rgba(0, 0, 0, 0.5);
}

:deep(.el-carousel__indicators--outside) {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

:deep(.el-carousel__indicator.is-active .el-carousel__button) {
  background-color: #fff;
  transform: scale(1.2);
}

@media (max-width: 768px) {
  .page-content {
    flex-direction: column;
  }
  
  .left-nav {
    width: 100%;
    position: relative;
    top: 0;
  }
}
</style>